import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import TimetableLesson from "./TimetableLesson";

class TimetableDropdown extends React.Component {
  state = {
    isDroppedDown: false,
  };

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      this.setState({
        isDroppedDown: false,
      });
    }
  };

  render() {
    let dropdownClass = classNames({
      dropdown: true,
      "dropdown--is-visible": this.state.isDroppedDown,
    });
    return (
      <li className="other-apps__app-icon app-icon--apps timetable-dropdown">
        <button
          target="_blank"
          rel="noopener noreferrer"
          alt="app"
          onClick={this.toggleDropdown}
          className="apps-links has-dropdown cpanel-tooltip"
        >
          <img
            alt="Timetable Dropdown Icon"
            src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-timetable-icon.svg"
            className="app-icon app-icon-wordpress"
          />
          <span className="tooltiptext">Timetable</span>
        </button>
        <ul id="apps__dropdown" className={dropdownClass}>
          {this.props.timetableItems.map((timetable, timetableKey) => (
            <div className="timetable-day" key={timetableKey}>
              <h3>
                <span>{timetable[0]["day_name"]}</span>
              </h3>
              <TimetableLesson lessons={timetable[0]["processed_lessons"]} />
            </div>
          ))}
        </ul>
      </li>
    );
  }
}

export default TimetableDropdown;
